import i18next from 'i18next';
import authRoles from '../../auth/authRoles';
import ru from '../navigation-i18n/ru';
import uz from '../navigation-i18n/uz';

i18next.addResourceBundle('uz', 'navigation', uz);
i18next.addResourceBundle('ru', 'navigation', ru);

const navigationConfig = [
  {
    id: 'apps',
    title: 'Applications',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Basic',
    children: [
      {
        id: 'apps.home',
        title: 'HomePage',
        type: 'item',
        icon: 'react-outline:home',
        url: '/',
        translate: 'Main',
      },
      {
        id: 'myuzatom',
        title: 'MyUzAtom',
        type: 'collapse',
        icon: 'react-outline:building-office-2',
        translate: 'MyUzAtom',
        auth: authRoles.user,
        children: [
          {
            id: 'apps.structure',
            title: 'Structure',
            type: 'item',
            icon: 'react-outline:collection',
            url: '/apps/org-structure',
            translate: 'Structure',
          },
          {
            id: 'apps.map',
            title: 'Map',
            type: 'item',
            icon: 'react-outline:map-pin',
            url: '/apps/map',
            translate: 'Map',
          },
        ],
      },
      {
        id: 'apps.chat',
        title: 'Chat',
        type: 'item',
        auth: authRoles.user,
        icon: 'react-outline:chat-alt',
        url: '/apps/chat',
        translate: 'Chat',
      },
    ],
  },
  {
    id: 'work',
    title: 'Work',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Work',
    children: [
      {
        id: 'apps.projects',
        title: 'Projects Management',
        type: 'item',
        auth: authRoles.user,
        icon: 'react-outline:view-boards',
        url: '/apps/projects',
        translate: 'Projects',
        end: true,
      },
      {
        id: 'ElectronMail',
        title: 'ElectronMail',
        type: 'link',
        icon: 'react-outline:envelope',
        url: 'https://mail.uzatom.uz/',
        translate: 'ElectronMail',
      },
      {
        id: 'EIjro',
        title: 'EIjro',
        type: 'link',
        icon: 'react-outline:information-circle',
        url: 'https://edo.ijro.uz/welcome',
        translate: 'EDO.IJRO.UZ',
      },
      {
        id: 'hr',
        title: 'HR',
        type: 'collapse',
        icon: 'react-outline:users',
        translate: 'HumanResources',
        auth: authRoles.hr,
        children: [
          {
            id: 'departments',
            title: 'Departments',
            icon: 'react-outline:view-list',
            translate: 'Departments',
            type: 'item',
            url: 'hr/departments',
          },
          {
            id: 'users',
            title: 'Users',
            icon: 'react-outline:user-group',
            type: 'item',
            url: 'hr/users',
            translate: 'Users',
          },
          {
            id: 'hrm-employees',
            title: 'Users',
            icon: 'react-outline:user-group',
            type: 'item',
            url: 'hr/hrm-employees',
            translate: 'Employees',
          },
          {
            id: 'staff-table',
            title: 'Staffing table',
            icon: 'react-outline:table',
            type: 'item',
            url: 'hr/staff-table',
            translate: 'StaffTable',
          },
        ],
      },
      {
        id: 'admin',
        title: 'Administration',
        type: 'collapse',
        auth: authRoles.admin,
        icon: 'react-outline:cog',
        translate: 'Administration',
        children: [
          {
            id: 'apps.roles',
            title: 'Roles',
            type: 'item',
            icon: 'react-outline:adjustments',
            url: 'admin/roles',
            translate: 'Roles',
            end: true,
          },
          {
            id: 'apps.users',
            title: 'Users',
            type: 'item',
            icon: 'react-outline:user-group',
            url: 'admin/users',
            translate: 'Users',
            end: true,
          },
          {
            id: 'top-managers',
            title: 'Top managers',
            icon: 'react-outline:user',
            type: 'item',
            url: 'admin/top-managers',
            translate: 'TopManagers',
          },
          {
            id: 'apps.references',
            title: 'References',
            type: 'item',
            icon: 'react-outline:view-list',
            url: 'admin/references/Organizations',
            translate: 'References',
            end: true,
          },
          {
            id: 'apps.skills',
            title: 'Skills',
            type: 'item',
            icon: 'material-outline:auto_fix_high',
            url: 'admin/skills',
            translate: 'Skills',
            end: true,
          },
          {
            id: 'apps.claimexecutors',
            title: 'ClaimExecutors',
            type: 'item',
            icon: 'react-outline:flag',
            url: 'admin/claimexecutors',
            translate: 'ClaimExecutors',
            end: true,
          },
          {
            id: 'apps.crudMap',
            title: 'Maps',
            type: 'item',
            icon: 'react-outline:map',
            url: 'admin/crud-map',
            translate: 'Maps',
            end: true,
          },
          {
            id: 'apps.logs',
            title: 'Logs',
            type: 'item',
            icon: 'react-outline:document-text',
            url: 'admin/logs',
            translate: 'Logs',
            end: true,
          },
        ],
      },
      {
        id: 'apps.claims-processing',
        title: 'Projects Management',
        type: 'item',
        icon: 'react-outline:clipboard',
        url: '/apps/claims-processing',
        translate: 'ClaimsProcessing',
      },
    ],
  },
  {
    id: 'useful',
    title: 'Useful',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Useful',
    children: [
      {
        id: 'apps.profile',
        title: 'Profile',
        type: 'item',
        icon: 'react-outline:user-circle',
        url: '/apps/profile',
        translate: 'Profile',
      },
      {
        id: 'apps.appointments',
        title: 'Appointment',
        type: 'item',
        icon: 'react-outline:briefcase',
        url: '/apps/appointments',
        translate: 'Appointments',
      },
      {
        id: 'apps.skud',
        title: 'Skud',
        type: 'collapse',
        auth: authRoles.user,
        icon: 'react-outline:users',
        translate: 'SkudEmployees',
        children: [
          {
            id: 'skud-departments',
            title: 'Employees',
            type: 'item',
            icon: 'react-outline:clock',
            url: 'apps/skud/departments',
            translate: 'Skud',
            end: true,
          },
          {
            id: 'daily-attendances',
            title: 'Daily attendances',
            type: 'item',
            icon: 'react-outline:calendar',
            url: 'apps/skud/daily-attendances',
            translate: 'DailyAttendances',
            end: true,
          },
          {
            id: 'absence-asks',
            title: 'Absence asks',
            type: 'item',
            icon: 'react-outline:arrow-right-start-on-rectangle',
            url: 'apps/skud/absence-asks',
            translate: 'AbsenceAsks',
            end: true,
          },
          {
            id: 'workload',
            title: 'Workload',
            type: 'item',
            icon: 'react-outline:scale',
            url: 'apps/skud/workload',
            translate: 'Workload',
            end: true,
          },
          {
            id: 'skud-report',
            title: 'Report',
            type: 'item',
            auth: authRoles.hr,
            icon: 'react-outline:document-chart-bar',
            url: 'apps/skud/report',
            translate: 'SkudReport',
          },
        ],
      },
      {
        id: 'documents',
        title: 'documents',
        type: 'collapse',
        icon: 'react-outline:document-text',
        translate: 'Documents',
        auth: authRoles.user,
        children: [
          {
            id: 'apps.blank',
            title: 'Blanks',
            type: 'item',
            icon: 'react-outline:document',
            url: '/apps/blanks',
            translate: 'Blanks',
          },
          {
            id: 'apps.presentation',
            title: 'Presentation',
            type: 'item',
            icon: 'react-outline:presentation-chart-bar',
            url: '/apps/presentation',
            translate: 'Presentations',
          },
          {
            id: 'apps.internal-documents',
            title: 'InternalDocuments',
            type: 'item',
            icon: 'react-outline:document-text',
            url: '/apps/internal-documents',
            translate: 'InternalDocuments',
          },
        ],
      },
      {
        id: 'apps.calendar',
        title: 'Calendar',
        type: 'collapse',
        auth: authRoles.user,
        icon: 'react-outline:calendar',
        translate: 'Calendar',
        children: [
          {
            id: 'resources-calendar',
            title: 'Resources calendar',
            type: 'item',
            icon: 'react-outline:calendar',
            url: 'apps/calendar/resources',
            translate: 'Reservation',
          },
          {
            id: 'my-calendar',
            title: 'My calendar',
            type: 'item',
            icon: 'react-outline:calendar',
            url: 'apps/calendar/my',
            translate: 'MyCalendar',
          },
        ],
      },
      {
        id: 'apps.helpcenter',
        title: 'HelpCenter',
        type: 'collapse',
        icon: 'react-outline:question-mark-circle',
        translate: 'HelpCenter',
        auth: authRoles.user,
        children: [
          {
            id: 'helpdesk',
            title: 'HelpDesk',
            type: 'item',
            icon: 'react-outline:phone',
            url: '/apps/helpdesk',
            translate: 'HelpDesk',
          },
          {
            id: 'support',
            title: 'Feedback',
            type: 'item',
            icon: 'react-outline:support',
            url: '/apps/support',
            translate: 'Feedback',
          },
          {
            id: 'download-app',
            title: 'Feedback',
            type: 'item',
            icon: 'react-outline:archive-box-arrow-down',
            url: '/apps/download-app',
            translate: 'DownloadApp',
          },
        ],
      },
    ],
  },
];

export default navigationConfig;
